<i18n>
{
  "en": {
    "reservation": {
      "type": {
        "inputLabel": "Reservation Type",
        "placeholder": "Select ride type...",
        "toAirport": "To Airport: Sea-Tac (Departing)",
        "fromAirport": "From Airport: Sea-Tac (Arriving)",
        "pointToPoint": "Point-to-Point",
        "multipleStop": "Multiple Stops",
        "hourly": "Hourly",
        "weddings": "Weddings",
        "typeError": "Online booking is not available for hourly, event, or multiple stop reservations. Please use our reservation request form."
      },
      "passengerCount": {
        "inputLabel": "Passengers",
        "placeholder": "Number of passengers...",
        "maxPassengerError": "Online booking is currently only available for vehicles up to 6 passengers. For larger groups, please make a request using our form for larger vehicles at <a class='errorlink' href='https://acestowncarservice.com/aces-vehicle-quote/'>https://acestowncarservice.com/aces-vehicle-quote/</a>"
      }
    }
  }
}
</i18n>

<template>
  <div class="ui segment" v-bind:class="{ loading: quoteInProgress }">
    <div class="ui form">
      <div class="field">
          <label>{{ $t('reservation.type.inputLabel') }}</label>
          <div v-on:change="reactToType()" class="ui selection dropdown">
              <input type="hidden" id="reservation-type" name="reservation-type" v-model="selected">
              <i class="dropdown icon"></i>
              <div class="default text">{{ $t('reservation.type.placeholder') }}</div>
              <div id="type-menu" class="sub menu" style="maxheight: 100%">
                  <div class="item" data-value="1">{{ $t('reservation.type.toAirport') }}</div>
                  <div class="item" data-value="2">{{ $t('reservation.type.fromAirport') }}</div>
                  <div class="item" data-value="3">{{ $t('reservation.type.pointToPoint') }}</div>
                  <div class="item" data-value="4">{{ $t('reservation.type.multipleStop') }}</div>
                  <div class="item" data-value="4">{{ $t('reservation.type.hourly') }}</div>
                  <div class="item" data-value="4">{{ $t('reservation.type.weddings') }}</div>
              </div>
          </div>
      </div>

      <div class="field">
        <label>Pickup</label>
        <input v-model="pickupDisplay" :disabled="pickupDisplay == 'Sea-Tac Airport'" type="text" id="pickup" name="pickup" placeholder="Pickup Address">
      </div>

      <div class="field">
        <label>Dropoff</label>
        <input v-model="dropoffDisplay" :disabled="dropoffDisplay == 'Sea-Tac Airport'" type="text" id="dropoff" name="dropoff" placeholder="Dropoff Address">
      </div>

      <div class="field">
        <label>{{ $t('reservation.passengerCount.inputLabel') }}</label>
        <div v-on:change="validatePassengers()" class="ui selection dropdown">
          <input v-model="passengers" id="passengers" type="hidden" name="passengers">
          <i class ="dropdown icon"></i>
          <div class="default text">{{ $t('reservation.passengerCount.placeholder') }}</div>
          <div id="passenger-menu" class="menu">
              <div class="item" data-value="1">1</div>
              <div class="item" data-value="2">2</div>
              <div class="item" data-value="3">3</div>
              <div class="item" data-value="4">4</div>
              <div class="item" data-value="5">5</div>
              <div class="item" data-value="6">6</div>
              <div class="item" data-value="99">7+</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui red inverted segment" v-for="(error, index) in errors" :key="index">
      <span v-html="error"></span>
    </div>
    <div class="ui modal" id="unsupportedRideTypeModal">
      <div class="header">
        <p>Sorry!</p>
      </div>
      <div class="content">
        <p>{{ $t('reservation.type.typeError') }}</p>
      </div>
      <div class="actions">
        <!-- Removing this until I figure out why I can't clear the drop down! -->
        <!-- <div class="ui deny button">Choose Another Type</div> -->
        <div class="ui approve button">Let's Go!</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { shakespeare } from './mixins/clients/shakespeare.js'
  import RideType from '../models/ride_type.js'

  export default {
    mixins: [shakespeare],
    name: 'Locations',
    props: {
      reservation: Object,
      quoteInProgress: Boolean
    },
    data: function () {
      return {
        selected: '',
        rideType: '',
        pickupDisplay: '',
        pickup: {},
        dropoffDisplay: '',
        dropoff: {},
        passengers: '',
        errors: {},
        completeStatus: {},
        complete: false
      }
    },
    methods: {
      testFun: function () {
        alert(this.selected)
      },
      validatePassengers: function () {
        this.passengers = $('#passengers').val()
        var passengerValidationKey = 'passengerValidation'
        if (this.passengers === '' || this.passengers < 99) {
          delete this.errors[passengerValidationKey]
        } else {
          var errrorText = this.$t('reservation.passengerCount.maxPassengerError')
          this.errors[passengerValidationKey] = errrorText
        }
        this.checkForComplete()
      },
      checkForComplete: function () {
        if (this.pickup === '') { this.completeStatus.pickup = true } else { this.completeStatus.pickup = false }
        if (this.dropoff === '') { this.completeStatus.dropoff = true } else { this.completeStatus.dropoff = false }
        if (this.passengers === '') { this.completeStatus.passengers = true } else { this.completeStatus.passengers = false }
        if (Object.keys(this.errors).length > 0) { this.completeStatus.errors = true } else { this.completeStatus.errors = false }
        var result = true
        for (var o in this.completeStatus) {
          if (this.completeStatus[o]) result = false
        }
        this.complete = result
        this.$emit('locationsComplete', this.complete)
        if (this.complete) {
          this.$emit('locationsSet', { pickup: this.pickup, dropoff: this.dropoff, passengers: this.passengers, rideType: this.rideType })
          this.getQuote(this.pickup.formatted, this.dropoff.formatted, this.passengers)
        }
      },
      reactToType: function () {
        var seaTac = {
          formatted: '17801 International Blvd, Seattle, WA 98158',
          streetAddress: '17801 International Blvd',
          city: 'Seattle',
          state: 'WA',
          zip: '98158'
        }
        var seaTacLabel = 'Sea-Tac Airport'
        this.selected = $('#reservation-type').val()
        var rideTypeValidationKey = 'rideTypeValidation'
        delete this.errors[rideTypeValidationKey]
        switch (this.selected) {
          case '1':
            this.setPickup('', '')
            this.setDropoff(seaTacLabel, seaTac)
            this.rideType = RideType.Types.AIRPORT_DROPOFF
            break
          case '2':
            this.setPickup(seaTacLabel, seaTac)
            this.setDropoff('', '')
            this.rideType = RideType.Types.AIRPORT_PICKUP
            break
          case '3':
            this.setPickup('', '')
            this.setDropoff('', '')
            this.rideType = RideType.Types.POINT_TO_POINT
            break
          case '4':
            this.setPickup('', '')
            this.setDropoff('', '')
            this.errors[rideTypeValidationKey] = this.$t('reservation.type.typeError')
            this.rideType = RideType.Types.ERROR
            this.showRideTypeModal()
            break
        }
        console.log('type changed to:' + this.rideType)
        this.$emit('rideTypeUpdated', this.rideType)
        this.checkForComplete()
      },
      isTypeSet: function () {
        return this.selected !== ''
      },
      initStuff: function () {
        var v = this
        var pickupInput = document.getElementById('pickup')
        var pickupAutocomplete = new google.maps.places.Autocomplete(pickupInput)

        var dropoffInput = document.getElementById('dropoff')
        var dropoffAutocomplete = new google.maps.places.Autocomplete(dropoffInput)

        var waBounds = {
          west: -123.9857102146,
          east: -120.4218054523,
          south: 46.4429925439,
          north: 48.9794468638
        }

        pickupAutocomplete.setOptions({ bounds: waBounds })
        dropoffAutocomplete.setOptions({ bounds: waBounds })

        pickupAutocomplete.addListener('place_changed', function () {
          var parsedAddress = v.parseAddress(this.getPlace().address_components)
          v.setPickup(parsedAddress['formatted'], parsedAddress)
        })

        dropoffAutocomplete.addListener('place_changed', function () {
          var parsedAddress = v.parseAddress(this.getPlace().address_components)
          v.setDropoff(parsedAddress['formatted'], parsedAddress)
        })
        this.checkForComplete()
      },
      parseAddress: function (place) {
        var p = {}
        place.forEach(function (element) {
          p[element.types[0]] = element['short_name']
        })
        p['formatted'] = p['street_number'] + ' ' + p['route'] + ', ' + p['locality'] + ', ' + p['administrative_area_level_1'] + ' ' + p['postal_code']
        return {
          formatted: p['formatted'],
          streetAddress: p['street_number'] + ' ' + p['route'],
          city: p['locality'],
          state: p['administrative_area_level_1'],
          zip: p['postal_code']
        }
      },
      setPickup: function (display, actual) {
        this.pickupDisplay = display
        this.pickup = actual
        this.checkForComplete()
      },
      setDropoff: function (display, actual) {
        this.dropoffDisplay = display
        this.dropoff = actual
        this.checkForComplete()
      },
      showRideTypeModal: function () {
        // var v = this
        $('#unsupportedRideTypeModal')
          .modal({
            closable: false,
            onDeny: function () {
              $('#reservation-type').dropdown('clear')
            },
            onApprove: function () {
              window.location = 'https://acestowncarservice.com/aces-hourly-request-form'
            }
          })
          .modal('show')
      }
    },
    mounted () {
      var v = this

      $(document)
        .ready(function () {
          v.initStuff()
          $('.dropdown').dropdown({
            clearable: true
          })
        })
    }
  }
</script>

<style>
  a.errorlink {
    color: white;
    text-decoration: underline;
  }
  #type-menu {
    max-height: 300px;
  }
  #passenger-menu {
    max-height: 300px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Locations.vue